import apiClient from "../lib/apiClient";

export const getUserContentUsageReport =
  async (userId) => {

    try {

      const response =
        await apiClient.get(
          `/LiveClasses/GetUserContentUsageReport?userId=${userId}`
        );

      return response.data;

    } catch (error) {

      console.log(
        "CONTENT USAGE API ERROR:",
        error
      );

      throw error;

    }

  };